import React, { useState, useEffect, useRef } from "react";
import axiosInstance from '../axiosInstance';
import { FaSearch, FaSortUp, FaSortDown, FaPen, FaPlus, FaEye, FaTrash, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { API_URL_All } from "../api";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as general from '../libs/general';
import Paging from '../components/Paging';
import ProductEditor from '../components/products/ProductEditor';
import UserLayout from "../components/UserLayout";
import DataTable from "../components/ui/DataTable";
import { useTranslation } from "react-i18next";

const UserProducts = () => {
  const { t } = useTranslation();
  const [productEditorData, setProductEditorData] = useState(null);
  const [pageData, setPageData] = useState({ content: [] });
  const [message, setMessage] = useState("");
  const hasRun = useRef(false);
  const [customerCodes, setCustomerCodes] = useState("");
  const config = general.getLocalStorage("user_config");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");


  useEffect(() => {
    searchProducts();
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const response = await axiosInstance.get(`/api/users/all`);
      const list = response.data.map(item => item.customerCode).filter(code => code);
      const uniqueList = [...new Set(list)];
      var joinedCodes = uniqueList.join(',');
      setCustomerCodes(joinedCodes);
    } catch (error) {
      console.error(error);
    }
  };
  const handleChangeItemsPerPage = (e) => {
    const newItemsPerPage = parseInt(e.target.value, 10);
    searchProducts({ page: 0, size: newItemsPerPage });
  };

  const handlePageChange = (page) => {
    searchProducts({ page: page - 1 });
  };
  const handleSearchChange = (e) => {
    var searchValue = e.target.value;
    searchProducts({ page: 0, keyword: searchValue });
    setSearchQuery(e.target.value);
  };

  const searchProducts = async (filter) => {
    if (window.calling) return;
    window.calling = true;
    setIsLoading(true);
    setMessage('');
    var params = general.getSession('search_userproducts');

    var formData = general.getFormData('.form_filter');
    Object.assign(params, formData);

    if (!hasRun.current) {
      hasRun.current = true;
      var oldParams = general.getSession('search_userproducts');
      Object.assign(params, oldParams);
    }

    if (filter) Object.assign(params, filter);
    general.setSession('search_userproducts', params);
    window.initializeFilterValue(params);

    var filteredParams = Object.fromEntries(Object.entries(params).filter(([key, v]) => v !== undefined && v !== '' && key + v !== 'page0' && key + v !== 'size550' && key + v !== 'isDeletedfalse'));

    var response = {};
    try {
      response = await axiosInstance.get('/api/products/searchProducts', { params: filteredParams });
      setPageData(response.data);
    } catch (error) {
      setPageData({ content: [] });
      setMessage(error.message);
      console.error(error);
      toast.error(error.message);
    } finally {
      window.calling = false;
      setIsLoading(false);
    }
  };
  const openProductAdminEditor = (id) => {
    setProductEditorData({ id: id });
  };

  return (
    <div>
      <UserLayout>
        <div className="table-responsive web-table">
          <div className="container-fluid">
            <div className="row bg-zto">
              <div className="col-6 col-md-3 pt-1 pb-1 fw-bold text-white d-flex align-items-center justify-content-star title-ad flex-wrap gap-1">
                <span className="text-uppercase">{t("header.productsSection")}</span>
              </div>
              <div className="col-6 col-md-4 pt-1 pb-1">
                <form id="form_filter" className="form_filter">
                  <div className="input-group search-block">
                    <input name="keyword"
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Tìm kiếm..."
                      value={searchQuery}
                      onChange={(e) => handleSearchChange(e)}  // Ensure `e` is passed to the function
                    />
                    <button className="btn btn-light btn-sm" type="button" title="Tìm kiếm..." onClick={(event) => searchProducts({ page: 0 })}>
                      <FaSearch />
                    </button>
                  </div>
                </form>
              </div>
              <div className="py-1 col-md-5 flex-end">


                {config.code && (
                  <div>
                    <button className="btn btn-success btn-sm" onClick={() => openProductAdminEditor(0)} title="Thêm đơn hàng">
                      <FaPlus />
                    </button>
                  </div>
                )}

              </div>
            </div>


          </div>

          <section>
            <DataTable maxHeight="calc(100vh - 186px)" className="table-normal" data-loading={isLoading}>
              <table className="table table-striped table-bordered border-normal">
                <thead className="table-primary">
                  <tr>
                    <th width="30px" className="sticky text-center">STT</th>
                    <th width="150px"><span>Mã sản phẩm</span></th>
                    <th><span>Tên sản phẩm</span></th>
                    <th><span>Hình ảnh</span></th>
                    <th><span>Giá nhập</span></th>
                    <th><span>Giá khai báo</span></th>
                    <th><span>Mã HS</span></th>
                    <th><span>Thuế nhập (%)</span></th>
                    <th><span>Thuế vat (%)</span></th>
                    <th width="100px" className="text-center">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  {pageData.page && pageData.page.content && pageData.page.content.map((item, index) => (
                    <tr key={item.id}>
                      <td className="sticky text-center">{(pageData.page.number * pageData.page.size) + index + 1}</td>
                      <td
                        className="text-start text-primary"
                        role="button"
                        style={{ cursor: "pointer" }}
                        onClick={() => openProductAdminEditor(item.id)}
                        title="Xem chi tiết sản phẩm"
                      >
                        {item.code}
                      </td>
                      <td className="text-start" data-product-type={item.productType}>{item.name}</td>
                      <td width="100px" className="text-start over-visible">
                        <div className="img-incol">
                          <img src={`${API_URL_All}/${item.imagePath}`} />
                          <img className="popup-image" src={`${API_URL_All}/${item.imagePath}`} />
                        </div>
                      </td>
                      <td className="text-end">{item.price ? item.price.toLocaleString("vi-VN") : ""}</td>
                      <td className="text-end">{item.priceDeclare ? item.priceDeclare.toLocaleString("vi-VN") : ""}</td>

                      <td className="text-start">{item.taxCode}</td>
                      <td className="text-start">{item.taxImport}</td>
                      <td className="text-start">{item.taxVat}</td>
                      <td className="text-center">
                        <div>
                          {item.productType !== 'share' && (
                            <FaPen className="text-primary me-2" onClick={() => openProductAdminEditor(item.id)} size={15} title="Cập nhật" />
                          )}
                          {item.productType === 'share' && (
                            <FaEye className="text-primary me-2" onClick={() => openProductAdminEditor(item.id)} size={15} title="Chi tiết" />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}

                  {message === '' && pageData.page && pageData.page.content.length === 0 && (
                    <tr>
                      <td colSpan="10" className="text-center">Không tìm thấy dữ liệu</td>
                    </tr>
                  )}
                  {message !== '' && (
                    <tr>
                      <td colSpan="10" className="text-center">{message}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </DataTable>
          </section>
          <div className="mt-2 d-flex justify-content-end align-items-center">
            <Paging
              pageData={pageData}
              onPageChange={handlePageChange}
              onItemsPerPageChange={handleChangeItemsPerPage}
            />
          </div>
        </div>

        <input type="hidden" id="list_customers" value={customerCodes} />

        {productEditorData && (
          <ProductEditor data={productEditorData} handleSearch={searchProducts} />
        )}

      </UserLayout>
    </div>
  );
}
export default UserProducts;